<template>
  <div
    class="block bg-nucleus-white hover:bg-nucleus-listBgHover hover:border-nucleus-listBgHover p-3 text-nucleus-text rounded transition flex border border-nucleus-white mb-1 link"
  >
    <div
      class="icon text-3xl leading-none p-2 text-nucleus-text mr-6 flex self-center transition bg-nucleus-iconBg rounded-full"
      :class="'icon-' + icon"
    ></div>
    <div>
      <div class="font-bold">{{ name }}</div>
      <div class="text-nucleus-grey">{{ room }}</div>
      <div class="text-sm mt-1" :class="getStatusColor()">
        {{ getStatusName(status) }}
      </div>
      <div class="text-nucleus-grey">{{ notes }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapAwsUserStatus } from "@/utils/awsMappings";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    icon: String,
    room: String,
    status: String,
    notes: String,
  },
  methods: {
    getStatusColor() {
      const text = this.status.toLowerCase();
      switch (text) {
        case "active":
        case "started":
        case "enabled":
        case "joined":
        case "verified":
        case "confirmed":
          return "text-nucleus-primaryBlue font-bold";
        case "pending":
          return "text-nucleus-text";
        case "failed":
        case "declined":
        case "reset_required":
        case "force_password_change":
          return "text-nucleus-error font-bold";
        default:
          return "text-nucleus-text";
      }
    },
    getStatusName(name: string) {
      return this.$t(mapAwsUserStatus(name));
    },
  },
})
export default class ListItem extends Vue {}
</script>

<style lang="scss" scoped>
.link {
  &.router-link-active {
    @apply bg-nucleus-listBgActive border-nucleus-listBorderActive;
    .icon {
      @apply bg-nucleus-primaryBlue text-nucleus-white;
    }
  }
}
</style>
